"use client";

/**
 * User chat message bubble (right-aligned, navy background).
 *
 * Extracted from the prototype `compass-intake.jsx:76` (the `U` / `.cs-u` class).
 */

import type { ReactNode } from "react";

export interface UserBubbleProps {
  /** Message content. */
  children: ReactNode;
}

/**
 * User-side chat bubble: right-aligned, light-blue pill with dark text.
 *
 * Design (Aug 12): recoloured from navy to the info-tinted `--bg-sky` with dark
 * text so user replies read as messages, not actionable buttons. 12px radius on
 * all corners, 4px on the bottom-right for the "speech bubble tail" asymmetry.
 */
export function UserBubble({ children }: UserBubbleProps) {
  return (
    <div
      className={[
        "ml-auto max-w-[420px]",
        "bg-(--bg-sky) text-(--fg-primary)",
        "rounded-[12px]",
        "px-[16px] py-[11px]",
        "text-[14px] leading-[1.55]",
        "animate-[fadeSlideIn_300ms_var(--ease)_both]",
      ].join(" ")}
      style={{ borderBottomRightRadius: "4px" }}
    >
      {children}
    </div>
  );
}
